<template>
  <b-alert
    v-if="shown"
    show
    :variant="state.visible.length ? 'danger' : 'warning'"
    class="maintenance-banner d-flex flex-wrap align-items-center justify-content-between mb-1"
  >
    <div class="py-50 pr-1">
      <feather-icon
        :icon="state.visible.length ? 'AlertOctagonIcon' : 'ClockIcon'"
        class="mr-50"
      />
      <maintenance-status-text :state="state" />
    </div>
    <div class="d-flex flex-wrap align-items-center">
      <b-button
        v-if="state.visible.length && state.bypassConfigured"
        variant="danger"
        size="sm"
        class="mr-50 my-25"
        :disabled="opening"
        @click="open"
      >
        <feather-icon icon="LogInIcon" /> Войти на сайт
      </b-button>
      <span
        v-else-if="state.visible.length"
        class="small mr-50 my-25"
      >
        Вход под заглушку не настроен на сервере (нет MAINTENANCE_BYPASS_SECRET)
      </span>
      <b-button
        v-if="$route.name !== 'maintenance'"
        :variant="state.visible.length ? 'outline-danger' : 'outline-warning'"
        size="sm"
        class="my-25"
        :to="{ name: 'maintenance' }"
      >
        Управление заглушкой
      </b-button>
    </div>
  </b-alert>
</template>

<script>
import { BAlert, BButton } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  describeMaintenance, maintenanceState, openBehindMaintenance, subscribeMaintenance,
} from '@/views/maintenance/maintenance-state'
import MaintenanceStatusText from '@/views/maintenance/MaintenanceStatusText.vue'

/**
 * On every admin page while visitors see the maintenance page, or while a switch is on its way to the edge router:
 * what is shown and why, and the way past it. Follows saves on the «Заглушка» page without a reload.
 */
export default {
  name: 'MaintenanceBanner',
  components: { BAlert, BButton, MaintenanceStatusText },
  data() {
    return { opening: false, unsubscribe: null }
  },
  computed: {
    state() {
      return describeMaintenance(maintenanceState.overview)
    },
    shown() {
      const s = this.state
      return s.known && (s.visible.length > 0 || !!s.pending || (s.manual && s.noReports))
    },
    applied() {
      return maintenanceState.applied
    },
    slow() {
      return maintenanceState.slow
    },
  },
  watch: {
    /** Here, not on the page: the toast comes on whatever page the admin went on to */
    applied(value) {
      if (!value) return
      if (value.target === 'off' && value.reasons.length) {
        this.toast('Ручной флаг снят', `Но заглушка остаётся: ${value.reasons.join('; ')}`, 'warning')
        return
      }
      this.toast(
        'Готово',
        value.target === 'on'
          ? `Посетители видят заглушку (применено за ${value.seconds} с)`
          : `Заглушка убрана, сайт открыт (применено за ${value.seconds} с)`,
        'success',
      )
    },
    slow(value) {
      if (!value) return
      this.toast(
        'Пока не применилось',
        `Прошло ${value.seconds} с, а edge-router ещё не ${value.target === 'on' ? 'показал' : 'убрал'} заглушку. Проверьте блок «Состояние на серверах».`,
        'warning',
      )
    },
  },
  created() {
    // Admins only: the endpoint answers 403 to everyone else
    if (this.$can('manage', 'ACL')) this.unsubscribe = subscribeMaintenance()
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe()
  },
  methods: {
    async open() {
      this.opening = true
      try {
        await openBehindMaintenance()
      } catch (e) {
        this.toast('Ошибка', e.message, 'danger')
      } finally {
        this.opening = false
      }
    },
    toast(title, text, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title, text, variant, icon: variant === 'success' ? 'CheckCircleIcon' : 'AlertTriangleIcon',
        },
      })
    },
  },
}
</script>

<style scoped>
.maintenance-banner {
  padding: 0.5rem 1rem;
}
</style>
